import React, { useEffect, useState, useContext } from "react";
import Input from "../../shared/components/Input";
import {
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";

const ChangeMinorModal = (props) => {
	const [isLoading, setIsLoading] = useState(true);

	const dispatch = useDispatch();

	const [formState, inputHandler, setFormData] = useForm(
		{
			title: {
				value: "",
				isValid: false,
			},
			count: {
				value: "",
				isValid: false,
			},
			totalPrice: {
				value: "",
				isValid: false,
			},
			discountPrice: {
				value: "",
				isValid: false,
			},
		},
		false
	);

	useEffect(() => {
		setFormData(
			{
				title: {
					value: props.title,
					isValid: true,
				},
				count: {
					value: props.count,
					isValid: true,
				},
				totalPrice: {
					value: props.totalPrice,
					isValid: true,
				},
				discountPrice: {
					value: props.discountPrice,
					isValid: true,
				},
			},
			true
		);
		setIsLoading(false);
	}, [setFormData]);

	const receiptMinorChangeHandler = (event) => {
		event.preventDefault();
		dispatch({
			type: "updateDetail",
			payload: {
				minorId: props.minorId,
				detail: {
					title: formState.inputs.title.value,
					count: formState.inputs.count.value,
					totalPrice: Number(formState.inputs.totalPrice.value),
					discountPrice: Number(formState.inputs.discountPrice.value),
				},
			},
		});

		props.close();
	};

	if (isLoading) {
		return (
			<div style={{ justifyContent: "center", display: "flex" }}>
				<CircularProgress color="inherit" />
			</div>
		);
	}
	return (
		<React.Fragment>
			<form onSubmit={receiptMinorChangeHandler}>
				<Paper
					sx={{ flexGrow: 1, maxWidth: 1200, p: 2, m: 1 }}
					elevation={2}
				>
					<Grid container spacing={1}>
						<Grid md={6} xs={12}>
							<Input
								id="title"
								element="input"
								label="عنوان"
								validators={[VALIDATOR_REQUIRE()]}
								errorText="لطفا عنوان را وارد کنید"
								onInput={inputHandler}
								initialValue={formState.inputs.title.value}
								inputValid={formState.inputs.title.isValid}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="count"
								element="number_only"
								label="تعداد"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا تعداد را به درستی وارد کنید"
								onInput={inputHandler}
								initialValue={formState.inputs.count.value}
								inputValid={formState.inputs.count.isValid}
								type="text"
								needsThousandSeparator
								inputProps={{ min: 0 }}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="totalPrice"
								element="number_only"
								label="قیمت کل"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا قیمت کل را به درستی وارد کنید"
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
								needsThousandSeparator
								initialValue={formState.inputs.totalPrice.value}
								inputValid={formState.inputs.totalPrice.isValid}
							/>
						</Grid>
						<Grid md={6} xs={12}>
							<Input
								id="discountPrice"
								element="number_only"
								label="قیمت پس از تخفیف"
								validators={[
									VALIDATOR_REQUIRE(),
									VALIDATOR_NUMBER_ONLY(),
								]}
								errorText="لطفا قیمت پس از تخفیف را  به درستی وارد کنید"
								onInput={inputHandler}
								type="text"
								inputProps={{ min: 0 }}
								needsThousandSeparator
								initialValue={
									formState.inputs.discountPrice.value
								}
								inputValid={
									formState.inputs.discountPrice.isValid
								}
							/>
						</Grid>
						<Grid xs={12} md={6}>
							<Button
								disabled={!formState.isValid}
								type="submit"
								fullWidth
								color="secondary"
								variant="contained"
							>
								<EditIcon />
							</Button>
						</Grid>
						<Grid xs={12} md={6}>
							<Button
								fullWidth
								color="primary"
								variant="contained"
								onClick={props.close}
							>
								<ArrowBackIcon />
							</Button>
						</Grid>
					</Grid>
				</Paper>
			</form>
		</React.Fragment>
	);
};

export default ChangeMinorModal;
